import { gql } from '@apollo/client';

export const AdminNumocoOrders = gql`
  query adminNumocoOrders($statuses: [String]) {
    adminNumocoOrders(statuses: $statuses) {
      _id
      status
      name
      created_at
      buyer_company_name
      supplier_company_name
      total_amount
      order_number
    }
  }
`;

export const AdminNumocoSingleOrder = gql`
  query adminNumocoSingleOrder($orderId: String!) {
    adminNumocoSingleOrder(orderId: $orderId) {
      _id
      status
      name
      created_at
      buyer_company_name
      buyer_site_id
      supplier_company_name
      seller_site_id
      total_amount
      order_number
      delivery_address
      pickup_address
      purchase_orders {
        id
        status
        po_number
      }
      invoices {
        id
        status
        due_date
        close_time
        invoice_number
        was_sent
        total_amount
      }
      items {
        _id
        description
        quantity
        unit_cost
        line_total
        itemName
        reference_id
      }
      packing_list_pdf_url
      generated_sheets {
        type
        path
      }
      packingListContacts
    }
  }
`;

export enum InvoiceStatus {
  OPEN = 'OPEN',
  VOIDED = 'VOIDED',
  PAID = 'PAID',
  PENDING = 'PENDING',
  DRAFT = 'DRAFT',
}

export enum POStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  READY_TO_SEND = 'READY_TO_SEND',
}

export interface NumocoOrderItem {
  _id: string;
  description: string;
  itemName: string;
  quantity: number;
  unit_cost: number;
  line_total: number;
  reference_id: string;
}

export interface AdminNumocoSingleOrderRow {
  _id: string;
  status: string;
  name: string;
  created_at: Date;
  buyer_company_name: string;
  buyer_site_id: string;
  supplier_company_name: string;
  seller_site_id: string;
  total_amount: number;
  order_number: number;
  delivery_address: string;
  pickup_address: string;
  purchase_orders: {
    id: string;
    status: POStatus;
    po_number: string;
  }[];
  invoices: {
    id: string;
    status: InvoiceStatus;
    due_date: Date;
    close_time: Date;
    invoice_number: string;
    was_sent: boolean;
    total_amount: number;
  }[];
  items: NumocoOrderItem[];
  packing_list_pdf_url: string;
  generated_sheets: {
    type: string;
    path: string;
  }[];
  packingListContacts: string[];
}

export interface AdminNumocoSingleOrderType {
  adminNumocoSingleOrder: AdminNumocoSingleOrderRow;
}
